import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = ['Actividades listas para usar hoy, sin preparación', 'Checklist de hitos por edad: sabés cómo está tu hijo', 'Señales de alerta claras: cuándo consultar y cuándo no', 'Rutina diaria estructurada para cada etapa', 'Materiales del hogar: sin gastos extra ni complicaciones', 'Lenguaje sin tecnicismos: entendés todo aunque no seas profesional', 'Contexto 100% argentino: cultura, recursos y obras sociales', 'Imprimibles y tarjetas para usar en papel o pantalla', 'Optimizado para celular y tablet: lo abrís donde estés', 'Edición 2026: información actualizada y vigente'];
  return <section className="py-12 bg-sky-950 border-y border-sky-900" data-id="element-179">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-180">
        <h3 className="text-2xl font-bold text-center mb-10 text-white" data-id="element-181">
          ✅ Cada tomo incluye:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-182">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-sky-900/50 transition-colors" data-id="element-183">
              <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-184" />
              <span className="text-sky-50 font-medium text-[16px]" data-id="element-185">
                {item}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}